module.exports = __webpack_public_path__ + "img/product-default-sm-bw.d8b8ba07.jpg";